import "./App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz.js";
import FAQ from "./pages/Faq";
import Results from "./pages/Results";
import QuizIntroduction from "./pages/QuizIntroduction";

// App.js
function App() {
  const [quizState, setQuizState] = useState({
    currentPersonIndex: 0,
    totalPeople: 2,
    responses: [],
    isComplete: false,
  });

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/quiz-introduction"
          element={
            <QuizIntroduction
              quizState={quizState}
              setQuizState={setQuizState}
            />
          }
        />
        <Route
          path="/quiz"
          element={<Quiz quizState={quizState} setQuizState={setQuizState} />}
        />
        <Route
          path="/results"
          element={
            <Results quizState={quizState} setQuizState={setQuizState} />
          }
        />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
